<template>
  <generic-modal
    v-bind="$props"
    :value="value"
    confirm-text="confirm changes"
    title="Save Changes"
    subtitle-class="mt-2"
    :hide-louis="hideLouis"
    persistent
    v-on="$listeners"
  >
    <template #subtitle>
      <slot name="subtitle">Please confirm that the changes you've made are correct.</slot>
    </template>
    <slot />
  </generic-modal>
</template>

<script>
import GenericModal from '@/components/modals/generic-modal'

export default {
  name: 'SaveModal',
  components: {
    GenericModal,
  },
  props: {
    hideLouis: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
